export function downloadFile(action) {
  fetch(action, {
    method: 'GET',
    headers: {
      'bbfAdminTeacherToken': `${window.localStorage.getItem('bbfAdminTeacherToken')}`
    }
  })
    .then(response => {
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      return response.blob();
    })
    .then(blob => {
      const timestamp = Date.now(); // 获取当前时间戳
      const fileName = `${timestamp}.xlsx`; // 使用时间戳作为文件名
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = fileName; // 设置下载的文件名为时间戳
      document.body.appendChild(a);
      a.click();
      a.remove();
      window.URL.revokeObjectURL(url);
    })
    .catch(error => {
      console.error('There has been a problem with your fetch operation:', error);
    });
}